/**
 * Caixa e gestão em janelas próprias, com nome: passar de uma para a outra
 * traz a janela que já está aberta para a frente em vez de abrir outra (ou de
 * recarregar a caixa e perder a venda a meio).
 */
export const CAIXA_WINDOW = 'makila-caixa';
export const GESTAO_WINDOW = 'makila-gestao';

export function switchTo(path: '/' | '/gestao') {
  const name = path === '/' ? CAIXA_WINDOW : GESTAO_WINDOW;
  // open('', nome) devolve a janela com esse nome, se existir, sem a navegar; senão abre uma em branco.
  const w = window.open('', name);
  if (!w) { location.href = path; return; }
  try {
    if (w.location.href === 'about:blank') w.location.href = path;
  } catch {
    w.location.href = path;
  }
  w.focus();
}
